import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { validateUser, setAuthUser } from "../redux/authSlice";
import { NAVIGATION_SOURCE } from "../utils/constants/navigationConstants";
import { checkRoutePermission } from "../utils/checkRoutePermission";
import { FORBIDDEN, LOGIN } from "./paths";
import { getUserPermission } from "../redux/roleManagementSlice";

export default function ProtectedRoute() {
  const { authUser, authUserloading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const location = useLocation();
  const source = location.state?.source;

  const { permissions, isfullAccess, permissionsLoading, permissionsFetched } =
    useSelector((state) => state.roleManagement);

  useEffect(() => {
    dispatch(validateUser());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getUserPermission());
  }, [dispatch]);

  useEffect(() => {
    const channel = new BroadcastChannel("auth");
    channel.onmessage = (event) => {
      if (event.data === "logout") {
        dispatch(setAuthUser(false));
      }
    };

    return () => channel.close();
  }, [dispatch]);

  if (authUserloading || permissionsLoading || !permissionsFetched) {
    return null;
  }

  if (authUser === false && source !== NAVIGATION_SOURCE.SIGNUP) {
    return <Navigate to={LOGIN} replace />;
  }

  const hasPermission = checkRoutePermission(
    location.pathname,
    permissions,
    isfullAccess
  );

  if (!hasPermission) {
    return <Navigate to={FORBIDDEN} replace />;
  }

  return <Outlet />;
}
